import {
  withTranslation,
} from 'react-i18next';

import RegattaRegistrationSectionView from './RegattaRegistrationSectionView';

const TranslatedComponent = withTranslation()(RegattaRegistrationSectionView);

const Component = TranslatedComponent;

export default Component;
